import {
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import cx from 'classnames';
import React from 'react';

import { Checkbox } from 'components/Checkbox';
import { RequiredIcon } from 'components/RequiredIcon';
import { Typography } from 'components/Typography';

import { useStyles } from './styles';

export type ConsentCheckboxProps = React.ComponentProps<typeof Checkbox> & {
  label: React.ReactNode;
  error?: boolean;
  errorLabel?: React.ReactNode;
};

export const ConsentCheckbox: React.VFC<ConsentCheckboxProps> = ({
  label,
  error,
  errorLabel,
  ...rest
}) => {
  const styles = useStyles();

  const consentLabel = (
    <>
      {label}&nbsp;
      <RequiredIcon display="inline-block" color="error" />
      <FormHelperText display="block" component={Typography} error={error}>
        {error && errorLabel}
      </FormHelperText>
    </>
  );

  return (
    <FormControl>
      <FormControlLabel
        className={styles.checkboxLabel}
        control={
          <Checkbox
            className={cx(styles.checkbox, { [styles.checkboxError]: error })}
            {...rest}
          />
        }
        label={consentLabel}
      />
    </FormControl>
  );
};
